export default __webpack_public_path__ + "static/platformOverview-fa2c78ef5320562905473d9fe6309032.webp";